import { render } from "./ShowMailDetails.vue?vue&type=template&id=3af58a57"
import script from "./ShowMailDetails.vue?vue&type=script&lang=js"
export * from "./ShowMailDetails.vue?vue&type=script&lang=js"

import "./ShowMailDetails.vue?vue&type=style&index=0&id=3af58a57&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__